import React from 'react';
import PropTypes from 'prop-types';

import {
  Card,
  DataTable,
  DataTableColumn,
  Dropdown,
  DataTableRowActions,
} from '@salesforce/design-system-react';
import IllustrationNoContent from '../Illustrations/IllustrationNoContent';

const CollaboratorTable = (props) => {
  const tableActions = [
    {
      id: 0,
      label: 'Collaborate',
      value: 'update_collaborator',
      leftIcon: {
        category: 'utility',
        name: 'trail',
      },
    },
  ];

  const card = (
    <Card heading="Demo Journeys Shared with Me">
      <div style={{ maxHeight: '45vh', overflow: 'auto' }}>
        <DataTable items={props.items} fixedHeader fixedLayout>
          <DataTableColumn
            label="Journey Name"
            primaryColumn
            property="journey_name"
          />

          <DataTableColumn label="Owner" primaryColumn property="owner" />

          <DataTableColumn
            truncate
            title="Status"
            label="Status"
            property="finished"
          />
          <DataTableColumn
            truncate
            title="Date Created"
            label="Date Created"
            property="created"
          />
          <DataTableRowActions
            onAction={props.handleRowAction}
            dropdown={
              <Dropdown length="5" width="x-small" options={tableActions} />
            }
          />
        </DataTable>
      </div>
    </Card>
  );

  const emptyCard = (
    <Card heading="Shared Journeys" className="slds-m-left_small">
      <div className="slds-m-vertical_medium">
        <IllustrationNoContent
          title="No Journeys"
          details="Once you start or finish a Journey, you can see it here"
        />
      </div>
    </Card>
  );
  if (!props.items) {
    return emptyCard;
  }
  return props.items.length === 0 ? emptyCard : card;
};

CollaboratorTable.propTypes = {
  items: PropTypes.array,
  handleRowAction: PropTypes.func.isRequired,
};

export default CollaboratorTable;
